<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card class="elevation-12" :class="{error: config.status.animate}" width="100%" max-width="400">
            <v-card-text>
              <v-img contain :src="logo" height="150" aspect-ratio="1"></v-img>
              <v-window v-model="config.window">
                <v-window-item value="login">
                 <v-form ref="form1" v-model="form.valid" lazy-validation>
                   <v-flex xs12>
                     <v-text-field required
                       name="login"
                       ref="userid"
                       v-model="form.userid"
                       prepend-icon="person"
                       label="ユーザー名"
                       type="text"
                       :rules="rules.userid"
                       @keypress.enter.prevent="login"
                     ></v-text-field>
                   </v-flex>
                   <v-flex xs12>
                     <v-text-field required id="password"
                       v-model="form.passwd"
                       name="password"
                       prepend-icon="lock"
                       label="パスワード"
                       type="password"
                       :rules="rules.passwd"
                       @keypress.enter.prevent="login"
                     ></v-text-field>
                   </v-flex>
                   <p v-show="config.status.error" class="body-1 red--text text-xs-right">{{ printError }}</p>
                 </v-form>
                </v-window-item>
                <v-window-item value="init">
                 <v-form ref="form2" v-model="form.valid" lazy-validation>
                   <p class="body-1 text-xs-left">初めてログインしたお客様には<br />新しいパスワードの設定をお願いしております。</p>
                   <v-flex xs12>
                    <v-text-field v-model="form.init.passwd1" required
                      name="password"
                      label="新しいパスワード"
                      type="password"
                      :rules="rules.init.passwd1"
                      @keypress.enter.prevent="submit"
                    ></v-text-field>
                   </v-flex>
                   <v-flex xs12>
                    <v-text-field v-model="form.init.passwd2" required
                      label="新しいパスワード（確認）"
                      type="password"
                      :rules="rules.init.passwd2"
                      @keypress.enter.prevent="submit"
                    ></v-text-field>
                   </v-flex>
                   <p v-show="config.status.error" class="body-1 red--text text-xs-right">{{ printError }}</p>
                 </v-form>
                </v-window-item>
              </v-window>
            </v-card-text>
            <v-card-actions v-if="config.window === 'login'">
              <v-spacer></v-spacer>
              <v-btn class="blue darken-2 white--text" :loading="isLoading" @click="login">ログイン</v-btn>
            </v-card-actions>
            <v-card-actions v-else-if="config.window === 'init'">
              <v-spacer></v-spacer>
              <v-btn class="blue darken-2 white--text" :loading="isLoading" @click="submit">設定する</v-btn>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
const DEF = {
  CONFIG: {
    WINDOW: 'login'
  }
}
export default {
  name: 'login',
  components: {
  },
  data () {
    return {
      logo: require('@/assets/logo_square.png'),
      config: {
        window: DEF.CONFIG.WINDOW,
        status: {
          error: '',
          animate: false,
          loading: false,
          authed: false
        }
      },
      form: {
        valid: true,
        userid: '',
        passwd: '',
        init: {
          valid: true,
          passwd1: '',
          passwd2: ''
        }
      },
      rules: {
        userid: [
          v => !!v || ''
        ],
        passwd: [
          v => !!v || ''
        ],
        init: {
          passwd1: [
            v => !!v || '必須項目です',
            v => v.length > 7 || '最低8文字は必要です'
          ],
          passwd2: [
            v => !!v || '必須項目です',
            v => v === this.form.init.passwd1 || 'パスワードが一致しません'
          ]
        }
      },
      store: {
        cid: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.$set(this.config, 'window', DEF.CONFIG.WINDOW)
      this.$set(this, 'form', this.initForm())
      this.auth()
    },
    initForm: function () {
      return {
        valid: true,
        userid: this.$localStorage.get('userid'),
        passwd: '',
        init: {
          valid: true,
          passwd1: '',
          passwd2: ''
        }
      }
    },
    auth: function () {
      const qs = this.$route.query
      const { t } = qs
      if (t) {
        this.verify(t)
      } else {
        this.$router.push('503')
      }
    },
    verify: function (token) {
      this.axios.post(`${this.$url.api}auth/t/url`, { token }).then(res => {
        this.$set(this.config.status, 'error', '')
        this.$set(this.config.status, 'loading', false)
        if (res.data.success) {
          this.$store.commit('config/update', { lit: token })
          this.$localStorage.set('lit', token)
          this.$set(this.store, 'cid', res.data.data.uid)
          this.$set(this.config.status, 'authed', true)
          this.$nextTick(() => {
            this.$refs.userid.focus()
          })
        } else {
          this.$router.push('503')
        }
      }).catch(err => {
        console.log(err)
        this.$router.push('503')
      })
    },
    login: function () {
      if (this.$refs.form1.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.axios.post(`${this.$url.api}auth/sign/jwt`, {
          cid: this.store.cid,
          userid: this.form.userid,
          passwd: this.form.passwd
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          if (res.data.success) {
            this.$localStorage.set('jwt', res.data.data.jwt)
            this.$localStorage.set('userid', this.form.userid)
            if (res.data.data.status === 'init') {
              this.$set(this.config, 'window', 'init')
            } else {
              this.$router.push('/')
            }
          } else {
            this.$set(this.config.status, 'error', 'fail')
            this.$set(this.config.status, 'animate', true)
            setTimeout(() => {
              this.$set(this.config.status, 'animate', false)
            }, 500)
          }
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'error', 'require')
        })
      } else {
        this.$set(this.config.status, 'error', 'require')
      }
    },
    submit: function () {
      if (this.$refs.form2.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.axios.post(`${this.$url.api}user/auth/test`, {
          passwd: this.form.init.passwd1
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          if (res.data.success) {
            if (!res.data.data) {
              this.axios.post(`${this.$url.api}user/auth/update/all`, {
                userid: this.$localStorage.get('userid'),
                passwd: this.form.init.passwd1
              }, {
                headers: {
                  'user-token': this.$localStorage.get('jwt')
                }
              }).then(res => {
                console.log(res)
                this.$set(this.config.status, 'loading', false)
                if (res.data.success) {
                  this.$router.push('/')
                }
              })
            } else {
              this.$set(this.config.status, 'error', 'match')
              this.$set(this.config.status, 'loading', false)
            }
          } else {
            this.$set(this.config.status, 'loading', false)
          }
        })
      }
    },
    unauthed: function () {

    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isAuthed () {
      return this.config.status.authed
    },
    printError () {
      return this.$error.login[this.config.status.error] ? this.$error.login[this.config.status.error] : ''
    }
  }
}
</script>

<style lang="scss">
#login {
  .v-card {
    &.error {
      animation: shaking .16s infinite;
    }
  }
}
</style>
